import { render, staticRenderFns } from "./setting.vue?vue&type=template&id=48e5f68d&scoped=true&"
import script from "./setting.vue?vue&type=script&lang=js&"
export * from "./setting.vue?vue&type=script&lang=js&"
import style0 from "./setting.vue?vue&type=style&index=0&id=48e5f68d&lang=stylus&scoped=true&"
import style1 from "./setting.vue?vue&type=style&index=1&id=48e5f68d&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48e5f68d",
  null
  
)

export default component.exports